__turbopack_context__.v({
  "carouselContainer": "component-module__ljKC9a__carouselContainer",
  "carouselImage": "component-module__ljKC9a__carouselImage",
  "dot": "component-module__ljKC9a__dot",
  "dots": "component-module__ljKC9a__dots",
  "photoInfo": "component-module__ljKC9a__photoInfo",
});
